export const fixChooserForm = ( chooser ) => {
	const chooserSection = chooser.parentNode;
	const chooserHeading = chooserSection.querySelector( 'h1' );
	let headingHeight = 0;

	if ( chooserHeading )
	{
		const headingStyle = chooserHeading.currentStyle || window.getComputedStyle( chooserHeading );

		headingHeight = chooserHeading.offsetHeight + parseFloat( headingStyle.marginBottom );
	}
	
	if ( window.innerWidth < 956 || chooser.offsetHeight >= chooserSection.offsetHeight - headingHeight )
	{
		chooser.classList.remove( 'fixed' );
		chooser.classList.remove( 'at-bottom' );
		chooser.removeAttribute( 'style' );
		
		return;
	}
	
	let margin;

	if ( window.innerWidth >= 1536 )
	{
		margin = 20;
	}
	else if ( window.innerWidth >= 1272 )
	{
		margin = 16;
	}
	else if ( window.innerWidth >= 956 )
	{
		margin = 12;
	}

	if ( !margin )
	{
		return;
	}

	const headerRect = document.querySelector( 'header' ).getBoundingClientRect();
	const sectionRect = chooser.parentNode.getBoundingClientRect();
	const notFixedChooserTop = chooser.nextElementSibling.getBoundingClientRect().top;
	const chooserTop = document.querySelector( 'div.site-submenu' ) ? headerRect.height + headerRect.top + document.querySelector( 'div.site-submenu' ).offsetHeight + margin : headerRect.height + headerRect.top + margin;
	const chooserHeight = window.innerHeight - chooserTop - margin;

	if ( window.innerWidth >= 956 && notFixedChooserTop <= chooserTop )
	{
		chooser.classList.add( 'fixed' );
		chooser.style.top = chooserTop + 'px';
		chooser.style.maxHeight = chooserHeight + 'px';

		if ( sectionRect.bottom <= chooser.offsetHeight + chooserTop )
		{
			chooser.classList.add( 'at-bottom' );
		}
		else
		{
			chooser.classList.remove( 'at-bottom' );
		}
	}
	else
	{
		chooser.classList.remove( 'fixed' );
		chooser.style.top = '';
		chooser.style.maxHeight = '';
	}
};
